import { Box, useTheme } from "@mui/material";
import type { FC } from "react";
import { InitialsAvatar } from "web_myplann/Shared/Components/InitialsAvatar";

type Props = {
	name: string;
	photo?: string;
};

export const ChatMessageAvatar: FC<Props> = ({ name, photo }) => {
	const theme = useTheme();
	const { avatar } = theme.chat;

	return (
		<Box
			width={avatar.size.xs}
			flexShrink={0}
			alignSelf="flex-end"
			mr={avatar.gap}
		>
			<Box className="chat_group_tail">
				<InitialsAvatar
					name={name}
					photo={photo}
					size={avatar.size.xs}
					initialsVariant="initials"
				/>
			</Box>
		</Box>
	);
};
